import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://printbanglabd.com/api',

});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// Auth
export const login = (data) => api.post('/api/auth/login', data);
export const register = (data) => api.post('/api/auth/register', data);
export const getMe = () => api.get('/api/auth/me');

// Projects
export const getProjects = () => api.get('/api/projects');
export const createProject = (data) => api.post('/api/projects', data);
export const updateProject = (id, data) => api.put(`/api/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/api/projects/${id}`);

// Templates
export const uploadTemplate = (formData) =>
  api.post('/api/templates/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getTemplates = () => api.get('/api/templates');
export const getTemplate = (id) => api.get(`/api/templates/${id}`);
export const getTemplateSvg = (id) => api.get(`/api/templates/${id}/svg`, { responseType: 'text' });
export const updateTemplateMapping = (id, mapping_json) =>
  api.put(`/api/templates/${id}/mapping`, { mapping_json });
export const createTemplate = (data) => api.post('/api/templates', data);
export const deleteTemplate = (id) => api.delete(`/api/templates/${id}`);

// Students
export const getStudents = (projectId) => api.get(`/api/projects/${projectId}/students`);
export const deleteStudent = (projectId, studentId) =>
  api.delete(`/api/projects/${projectId}/students/${studentId}`);
// Bulk delete: pass an array of ids, or null/omit to delete ALL entries in the project
export const bulkDeleteStudents = (projectId, ids = null) =>
  api.post(`/api/projects/${projectId}/students/bulk-delete`, { ids });
export const updateStudent = (projectId, studentId, data) =>
  api.put(`/api/projects/${projectId}/students/${studentId}`, data);
export const reprocessStudent = (projectId, studentId) =>
  api.post(`/api/projects/${projectId}/students/${studentId}/reprocess`);
// Admin photo (authenticated -> fetch as blob, then URL.createObjectURL)
export const getStudentPhoto = (projectId, studentId) =>
  api.get(`/api/projects/${projectId}/students/${studentId}/photo`, { responseType: 'blob' });

// Public client info
export const getProjectInfo = (token) => api.get(`/api/client/${token}/info`);
export const getPublicStudents = (token) => api.get(`/api/client/${token}/students`);
// Public photo URL (unauthenticated -> usable directly as <img src>)
export const publicStudentPhotoUrl = (token, studentId) =>
  `${api.defaults.baseURL}/api/client/${token}/students/${studentId}/photo`;

// Generation
export const generateCards = (projectId, mode = 'pending') =>
  api.post(`/api/projects/${projectId}/generate?mode=${mode}`);
export const getGenerationStatus = (projectId) => api.get(`/api/projects/${projectId}/status`);
// Downloads are plain links (no auth) so the browser's native downloader
// streams the file to disk with its own progress UI — no XHR blob in memory.
export const downloadAllUrl = (projectId, format = 'pdf') =>
  `${api.defaults.baseURL}/api/projects/${projectId}/download?format=${format}`;
export const downloadStudentUrl = (projectId, studentId, format = 'pdf') =>
  `${api.defaults.baseURL}/api/projects/${projectId}/students/${studentId}/download?format=${format}`;

// Storage management
export const clearProjectOutputs = (projectId) => api.delete(`/api/projects/${projectId}/outputs`);
export const clearStudentOutputs = (projectId, studentId) =>
  api.delete(`/api/projects/${projectId}/students/${studentId}/outputs`);

// Fonts
export const getFonts = () => api.get('/api/fonts');
export const uploadFont = (formData) =>
  api.post('/api/fonts', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteFont = (filename) => api.delete(`/api/fonts/${filename}`);

// Client
export const submitStudent = (token, formData) =>
  api.post(`/api/client/${token}/student`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const bulkUpload = (token, formData) =>
  api.post(`/api/client/${token}/bulk-upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updatePublicStudent = (token, studentId, data) =>
  api.put(`/api/client/${token}/students/${studentId}`, data);
